"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentRenderer = void 0;
const log_1 = require("../log");
const componentDebug = log_1.jrlDebug.extend('component');
const ComponentRenderer = ({ type, componentRegistrations, componentProps, middlewareProps, componentMiddleware, services, layoutApi, }) => {
    const component = componentRegistrations.get(type);
    if (component === undefined) {
        return null;
    }
    const componentServices = {
        services: services,
        layout: layoutApi,
    };
    // A middleware may call next with props, we should use them
    const render = (middlewareComponentProps, _, services) => {
        const props = middlewareComponentProps || componentProps;
        componentDebug('Rendering: %o', { type: component.type, props });
        const rendered = component.render(props, services.services) || null;
        return rendered;
    };
    const { componentType, componentRenderPath, ...rest } = componentProps;
    const middlewareRender = componentMiddleware({ layoutType: componentType, renderPath: componentRenderPath, ...rest }, middlewareProps, componentServices, render) || null;
    return middlewareRender;
};
exports.ComponentRenderer = ComponentRenderer;
exports.ComponentRenderer.displayName = 'ComponentRenderer';
//# sourceMappingURL=component-renderer.js.map